import React from 'react';
import { connect } from 'react-redux';

import { isProviderUser } from '../../util/onboarding';
import TopbarContainer from '../TopbarContainer/TopbarContainer';

import ProviderTopbar from './ProviderTopbar';

/**
 * A drop-in replacement for `<TopbarContainer />` on standalone (non-hub) pages that a provider can
 * reach — 404, email verification, no-access, the provider-booking confirm, class pages, etc. A
 * signed-in provider gets the minimal provider header (their dashboard menu) instead of the parent
 * topbar; everyone else (parents, anonymous visitors, admins) gets the normal TopbarContainer, with
 * all props forwarded (e.g. `currentPage`). Pages that need a distinct anon chrome (the legal + FAQ
 * pages via chromeForRole, and CMS pages) build their own role switch and don't use this.
 */
export const ProviderAwareTopbarComponent = ({ isProvider, ...rest }) =>
  isProvider ? <ProviderTopbar /> : <TopbarContainer {...rest} />;

const mapStateToProps = state => ({
  isProvider: isProviderUser(state.user.currentUser),
});

const ProviderAwareTopbar = connect(mapStateToProps)(ProviderAwareTopbarComponent);

export default ProviderAwareTopbar;
